<template>
  <q-page class="flex column game-assets">
    <div class="game-assets__filters">
      <UserTypeSelector
        @userTypeChange="updateUserTypes"
        :storeGetter="userTypeStoreGetter"
        :storeSetter="userTypeStoreSetter"
      />
    </div>

    <div class="game-assets__content">
      <GameAssetsDataTable
        :tableData="filteredProviders"
        tableTitle="Game Providers"
        :tableRowsPerPage="20"
        tableSortByKey="name"
        :tableDescending="false"
        @providerClicked="openProviderDropboxDialog"
      />
    </div>

    <Dialog
      :open.sync="dialogOpen"
      :title="dialogTitle"
      :fullscreen="true"
      :persistent="true"
    >
      <DropboxEmbed :url="dropboxEmbedLink" />
    </Dialog>
  </q-page>
</template>

<script>
import GameAssetsDataTable from "./GameAssetsDataTable.vue";
import Dialog from "@/components/dialog/Dialog.vue";
import DropboxEmbed from "@/components/other/DropboxEmbed.vue";
import UserTypeSelector from "@/components/filters/UserTypeSelector/";
import { providerBuilder, tableDataBuilder } from "./GameAssets.utils";
export default {
  name: "GameAssets",
  data() {
    return {
      loading: false,
      providerList: [],
      selectedUserTypes: [],
      dropboxEmbedLink: "",
      dialogTitle: "",
      dialogOpen: false,
    };
  },
  components: { GameAssetsDataTable, Dialog, DropboxEmbed, UserTypeSelector },
  methods: {
    fetchAllProviders() {
      const payload = {
        link: "game-providers",
        params: {
          populate: "user_types"
        }
      };
      this.$store
        .dispatch("fetchStrapiContent", payload)
        .then((response) => {
          this.providerList = (response && response.data && response.data.data) || [];
          this.loading = false;
        })
        .catch((error) => {
          this.errors.push(error);
          this.providerList = null;
        });
    },
    openProviderDropboxDialog(key, url) {
      this.dialogOpen = true;
      this.dialogTitle = key;
      this.dropboxEmbedLink = url;
    },
    updateUserTypes(types) {
      this.selectedUserTypes = types || [];
    },
    userTypeStoreGetter() {
      return this.$store.getters.getUserTypesGameAssets;
    },
    userTypeStoreSetter(payload) {
      return this.$store.commit("SET_USER_TYPES_GAME_ASSETS", {
        selectedUserTypesGameAssets: payload,
      });
    },
  },
  mounted() {
    this.fetchAllProviders();
  },
  computed: {
    filteredProviders() {
      const filterer = providerBuilder(this.selectedUserTypes);
      return tableDataBuilder(this.providerList.filter(filterer));
    },
  },
};
</script>
.<style lang="scss" scoped>
.game-assets {
  &__filters {
    background: #eeeeee;
    padding: 20px;
    margin-bottom: 10px;
  }
  &__content {
    padding: 20px;
  }
}
.body--dark {
  .game-assets {
    &__filters {
      background: #353535;
    }
  }
}
</style>
